import React, { useState, useContext } from "react";
import Button from "../../common/Button/Button";
import InputLogo from "../../common/InputLogo/InputLogo";
import Input from "../../common/Input/Input";
import { validateEmailWithFlexDomain, validatePassword } from "../../utils/validation.util";
import { ApiContext } from "../../context/MyContext";
import { useNavigate } from "react-router-dom";
import { Toaster } from "../../common/Toaster/Toaster";
import { userLogin } from "../../service/AuthWellDhanService";
import { useUtils } from "../../context/UtilsContext";
function LoginComponent() {

  const [formData, setFormData] = useState({ email: "", password: "" });
  const { updateMailId } = useContext(ApiContext);
  const navigate = useNavigate();
  const[ errorMessage, setErrorMessage] = useState("");
  const [errorType, setErrorType] = useState("");
  const [loading, setLoading] = useState(false);
  const { sessionUtils, loading: utilsLoading } = useUtils();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMessage("");
  setErrorType("");
  setLoading(true);

  const emailError = validateEmailWithFlexDomain(formData.email);
  if (emailError) {
    setErrorMessage(emailError);
    setErrorType("error");
    setLoading(false);
    return;
  }

  const eventTypes = sessionUtils?.event_types?.[0]?.event_types || [];
  const eventType = eventTypes.find(x => x.description === "user_login");
  const signinMode = sessionUtils?.signin_modes?.find(x => x.description === "welldhan_id");
  const appVersion = sessionUtils?.app_versions?.[0];

  if (!eventType?.id || !signinMode?.id || !appVersion?.id) {
    setErrorMessage("Something went wrong. Please wait for the page to load and try again.");
    setErrorType("error");
    setLoading(false);
    return;
  }

  if (!eventType?.id || !signinMode?.id || !appVersion?.id) {
    setErrorMessage("Something went wrong. Please wait for the page to load and try again.");
    setErrorType("error");
    setLoading(false);
    return;
  }



  const payload = {
    company_name: "flexcellence",
    application_name: "flexboard",
    app_version_id: appVersion.id,
    event_type_id: eventType.id,
    signin_mode_id: signinMode.id,
    login_input: formData.email,
    phone_ext_id: "", // If needed
    phone: "",        // If needed
    password: formData.password,
    google_id_token: "null",
  };

  try {
    const result = await userLogin(payload);

    if (result.success) {
      updateMailId(formData.email);
        // Store access_token for /verify-otp
  if (result.data?.data?.access_token) {
    localStorage.setItem('access_token', result.data.data.access_token);
  }
      const verifyOtpId = eventTypes.find(x => x.description === "verify_otp")?.id;
      // Get redirect path from localStorage if available
      const redirectPath = localStorage.getItem('redirectAfterLogin') || '/home';
      navigate("/otp", {
        state: {
          email: formData.email,
          type: "login",
          event_type_id: verifyOtpId,
          loginPayload: payload,
          redirectPath: redirectPath,
          flash: { type: "success", message: result.message || "Login successful. Enter the OTP." }
        }
      });
    } else {
      setErrorMessage(result.message);
      setErrorType("error");
    }
  } catch (err) {
    setErrorMessage("Login failed. Please try again.");
    setErrorType("error");
  }
  setLoading(false);
};
  const handleChangeOnclick =() =>{
    navigate("/signup");
  }
  return (
     <div className="w-full min-h-screen flex flex-col items-center justify-center">
       {errorMessage && <Toaster message={errorMessage} type={errorType} />}
    <div className="bg-app-bg w-full max-w-md rounded-2xl shadow-lg p-8 flex flex-col items-center">
     
      <InputLogo text="Login" />
      <form className="w-full flex flex-col items-center" onSubmit={handleSubmit}>
        <Input
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Enter email"
          validate={validateEmailWithFlexDomain}
          className="w-1/2 bg-input-bg"
        />
        <Input
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          placeholder="Enter password"
          validate={validatePassword}
          errorMessage="Please enter a valid password."
          className="w-1/2 bg-input-bg mt-5"
          type="password"
          required
        />
        {loading ? (
          <span className="loader mt-5"></span>
        ) : (
          <>
          <Button
            type="submit"
            text="Login"
            className="bg-orange-primary text-white w-1/2 mt-8"
            disabled={loading || utilsLoading}
          />
          <div className="w-full text-center mt-2 text-xs">
            <span
              className="text-orange-primary cursor-pointer underline"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </span>
          </div>
          </>
        )}
      </form>
      <div className="w-full text-center mt-2 text-xs">
        <p>
          Dont Have Account?{" "}<span className="text-orange-primary cursor-pointer underline" onClick={handleChangeOnclick}>Sign up</span>
        </p>
      </div>
    </div>
    </div>
  );
}

export default LoginComponent;
